import { render, staticRenderFns } from "./EditConsultant.vue?vue&type=template&id=824ac3b8"
import script from "./EditConsultant.vue?vue&type=script&lang=js"
export * from "./EditConsultant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports